<template>
	<div>
		<vxe-modal v-model="modal" :title="title" width="1200" height="600" @show="show" show-footer destroy-on-close>
			<template #default>
				<p>
					<vxe-radio-group v-model="selectTab">
						<vxe-radio-button label="errortype" content="按异常类型"></vxe-radio-button>
						<vxe-radio-button label="error" content="按异常明细"></vxe-radio-button>
						<vxe-radio-button label="delivery" content="按快递"></vxe-radio-button>
						<vxe-radio-button label="warehouse" content="按仓库"></vxe-radio-button>
					</vxe-radio-group>
				</p>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" height="400"
					:ref="gridRef"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			</template>
		</vxe-modal>
		<detail-index ref="detail" :data="currentdetail" :title="detailTitle" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import detailIndex from '../detail/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			},
			title: {
				default: () => {
					return ''
				}
			},
			bizDate: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				gridRef: Math.random(),
				selectTab: 'errortype',
				sourcedata: [],
				groupedData:[],
				modal: false,
				loading: false,
				count:[],
				list_formConfig: [],
				list_columns: [{
						field: 'errortype',
						title: '异常类型',
					},
					{
						field: 'num',
						title: '数量'
					},
					{
						field: 'amount',
						title: '赔付金额'
					},
					{
						field: 'percent',
						title: '金额占比(%)'
					},
					{
						field: '操作',
						width:60,
						align:'center',
						slots: {
							default:({row})=>{
								return <el-button type="text" style="font-size:12px" onClick={()=>{this.detailShow(row)}}>详情</el-button>
							}
						}
					}
				],
				list_footerField: [{
					field: 'num'
				}, {
					field: 'amount',
					fixed: 2
				}],
				detailTitle:'明细',
				currentdetail:[]
			}
		},
		watch: {
			selectTab() {
				if (this.selectTab == 'errortype') {
					this.list_columns = [{
							field: 'errortype',
							title: '异常类型',
						},
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'amount',
							title: '赔付金额',
							sortable: true
						},
						{
							field: 'percent',
							title: '金额占比(%)',
							sortable: true
						}
					]
				}
				if (this.selectTab == 'error') {
					this.list_columns = [{
							field: 'error',
							title: '异常明细',
						},
						{
							field: 'errortype',
							title: '异常类型',
						},
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'amount',
							title: '赔付金额',
							sortable: true
						},
						{
							field: 'percent',
							title: '金额占比(%)',
							sortable: true
						}
					]
				}
				if (this.selectTab == 'delivery') {
					this.list_columns = [{
							field: 'delivery_name',
							title: '快递',
						},
						{
							field: 'storage_name',
							title: '仓库',
						},
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'amount',
							title: '赔付金额',
							sortable: true
						},
						{
							field: 'percent',
							title: '金额占比(%)',
							sortable: true
						},
						{
							field: 'totalnum',
							title: '总包裹',
							sortable: true
						},
						{
							field: 'totalnumpercent',
							title: '总包裹占比(%)',
							sortable: true
						},
					]
				}
				if (this.selectTab == 'warehouse') {
					this.list_columns = [{
							field: 'storage_name',
							title: '仓库',
						},
						{
							field: 'error',
							title: '异常明细',
						},
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'amount',
							title: '赔付金额',
							sortable: true
						},
						{
							field: 'percent',
							title: '金额占比(%)',
							sortable: true
						}
					]
				}
				this.list_columns.push({
						field: '操作',
						width:60,
						align:'center',
						slots: {
							default:({row})=>{
								return <el-button type="text" style="font-size:12px" onClick={()=>{this.detailShow(row)}}>详情</el-button>
							}
						}
					})
				this.$refs[this.gridRef].reloadData([])	
				this.$refs[this.gridRef].commitProxy('query')
				this.$refs[this.gridRef].reloadColumn(this.list_columns)
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = this.list_columns
			},
			list() {
				console.log(this.bizDate)
				return new Promise((resolve) => {
					this.loading = true
					let tableData = []
					this.$api.compensationtrade.getSummary({
						bizDate: this.bizDate
					}).then((res) => {
						this.loading = false
						this.sourcedata = res.list
						this.count = res.count
						if (this.selectTab == 'errortype') {
							tableData = this.accordingToErrorType()
						}
						if (this.selectTab == 'error') {
							tableData = this.accordingToError()
						}
						if (this.selectTab == 'delivery') {
							tableData = this.accordingToDelivery()
						}
						if (this.selectTab == 'warehouse') {
							tableData = this.accordingToWarehouse()
						}		
						resolve({
							list: tableData
						})
						console.log(tableData)
					}, () => {
						this.loading = false
					})
				})

			},
			accordingToErrorType() {
				let amount = this.$Lodash.sumBy(this.sourcedata, 'amount')
				let tableData = []
				let groupedData = this.$Lodash.groupBy(this.sourcedata, 'errortype')
				for (let i in groupedData) {
					let obj = {}
					obj.id = groupedData[i][0].id
					obj.errortype = i
					obj.num = groupedData[i].length
					obj.amount = this.$Lodash.sumBy(groupedData[i], 'amount').toFixed(2)
					obj.percent = obj.amount / amount * 100
					obj.percent = obj.percent.toFixed(2)
					tableData.push(obj)
				}
				tableData = tableData.sort((a, b) => {
					return b.amount - a.amount
				})
				this.groupedData = groupedData
				return tableData
			},
			accordingToError() {
				let amount = this.$Lodash.sumBy(this.sourcedata, 'amount')
				let tableData = []
				let groupedData = this.$Lodash.groupBy(this.sourcedata, 'error')
				for (let i in groupedData) {
					let obj = {}
					obj.id = groupedData[i][0].id
					obj.error = i
					obj.num = groupedData[i].length
					obj.errortype = groupedData[i][0].errortype
					obj.amount = this.$Lodash.sumBy(groupedData[i], 'amount').toFixed(2)
					obj.percent = obj.amount / amount * 100
					obj.percent = obj.percent.toFixed(2)
					tableData.push(obj)
				}
				tableData = tableData.sort((a, b) => {
					return b.amount - a.amount
				})
				this.groupedData = groupedData
				return tableData
			},
			accordingToDelivery(){
				let sourcedata = this.sourcedata.filter((item)=>{
					return item.errortype=='快递异常'
				})
				let amount = this.$Lodash.sumBy(sourcedata, 'amount')
				let tableData = []
				let groupedData = this.$Lodash.groupBy(sourcedata, 'delivery_name')
				for (let i in groupedData) {
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'storage_name')
				}		
				for (let i in groupedData) {
					for(let j in groupedData[i]){				
						let total = this.count.find((item)=>{
							return item.delivery_uid == groupedData[i][j][0]['delivery_uid']
						})
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.delivery_name = i
						obj.storage_name = j
						obj.num = groupedData[i][j].length
						obj.amount = this.$Lodash.sumBy(groupedData[i][j], 'amount').toFixed(2)
						obj.percent = obj.amount / amount * 100
						obj.percent = obj.percent.toFixed(2)
						obj.totalnum = total?total.count:0
						if(obj.totalnum){
							obj.totalnumpercent = obj.num/obj.totalnum*100
							obj.totalnumpercent = obj.totalnumpercent.toFixed(2)
						}
						tableData.push(obj)
					}
				}
				tableData = tableData.sort((a, b) => {
					return b.amount - a.amount
				})
				this.groupedData = groupedData
				return tableData
			},
			accordingToWarehouse(){
				let sourcedata = this.sourcedata.filter((item)=>{
					return item.errortype=='发货异常'
				})
				let amount = this.$Lodash.sumBy(sourcedata, 'amount')
				let tableData = []
				let groupedData = this.$Lodash.groupBy(sourcedata, 'storage_name')
				for (let i in groupedData) {
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'error')
				}
				console.log(groupedData)
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.storage_name = i
						obj.error = j
						obj.num = groupedData[i][j].length		
						obj.amount = this.$Lodash.sumBy(groupedData[i][j], 'amount').toFixed(2)
						obj.percent = obj.amount / amount * 100
						obj.percent = obj.percent.toFixed(2)
						tableData.push(obj)
					}
					
				}
				tableData = tableData.sort((a, b) => {
					return b.amount - a.amount
				})
				this.groupedData = groupedData
				return tableData
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				this.modal = true
			},
			detailShow(row){
				console.log(row,this.groupedData)
				if(this.selectTab=='errortype'){
					this.detailTitle = '明细：'+row.errortype
					this.currentdetail = this.groupedData[row.errortype]
				}
				if(this.selectTab=='error'){
					this.detailTitle = '明细：'+row.error
					this.currentdetail = this.groupedData[row.error]
				}
				if(this.selectTab=='delivery'){
					this.detailTitle = '明细：'+row.delivery_name  +'——' +row.storage_name
					this.currentdetail = this.groupedData[row.delivery_name][row.storage_name]
				}
				if(this.selectTab=='warehouse'){
					this.detailTitle = '明细：'+row.storage_name +'——' +row.error
					this.currentdetail = this.groupedData[row.storage_name][row.error]
				}				
				this.$refs.detail.modalShow()
			},
			spanMethod({
				row,
				_rowIndex,
				column,
				visibleData
			}) {
				const fields = ['errortype', 'error']
				const cellValue = row[column.property]
				if (cellValue && fields.includes(column.property)) {
					const prevRow = visibleData[_rowIndex - 1]
					let nextRow = visibleData[_rowIndex + 1]
					if (prevRow && prevRow[column.property] === cellValue) {
						return {
							rowspan: 0,
							colspan: 0
						}
					} else {
						let countRowspan = 1
						while (nextRow && nextRow[column.property] === cellValue) {
							nextRow = visibleData[++countRowspan + _rowIndex]
						}
						if (countRowspan > 1) {
							return {
								rowspan: countRowspan,
								colspan: 1
							}
						}
					}
				}
			}
		},
		components: {
			detailIndex
		}
	}
</script>